import { gql } from '@apollo/client'
import React from 'react'

import { formsClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useFormReplyState = () => React.useContext(Context)
export const useFormReply = () => useFormReplyState()?.formReply

const QUERY = gql`
  query FormReply($shareCode: String) {
    formReply(shareCode: $shareCode) {
      id
      insertedAt
      place {
        id
        name
        resume
      }
      formId
      form {
        id
        configuration
      }
    }
  }
`

const FormReplyLoader = ({ children, shareCode }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { shareCode },
    client: formsClient,
    fetchPolicy: 'cache-first'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FormReplyLoader
